export function getDossierUrl(userData?: string | object | null): string {
  try {
    if (!userData) return '';
    const user = typeof userData === 'string' ? JSON.parse(userData) : userData;
    const { isAuthorInDossie, uid, channel } = user;
    const channelName = typeof channel === 'string' ? channel : channel?.name;
    if (uid && channelName) {
      const searchParams = new URLSearchParams({
        isauthor: String(isAuthorInDossie ?? false),
        from: 'global',
        uid: String(uid),
        channel: String(channelName),
        page: 'MeuPerfil',
      });
      return `/dossierinfluenciador?${searchParams.toString()}`;
    }
  } catch (e) {
    console.error('Error parsing userData', e);
  }
  return '';
}
